import client from './rest/AdminClient';

export const makeApiPostRequest = async (path, payload) => {
  try {
    const response = await client({
      method: 'POST',
      path,
      entity: JSON.stringify(payload),
    });
    return response?.entity || {};
  } catch (error) {
    return error;
  }
};

export const updateTerminalHoldStatus = async (body) => {
  return makeApiPostRequest('/admin/api/v2/jobs/bulk/hold_status', body);
};
